import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { Page } from "@/components";
import { getCanonicalAndLanguageAlternates, getChainInfo } from "@/utils";
import { NotificationsView } from "@/views";

const ProfilePage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = getChainInfo();
  const title = "Notifications";
  const description = "Browse and customize your profile notification settings on YOLO Games.";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    `/settings/notifications`,
    router,
    currentChainInfo.appUrl
  );

  return (
    <Page title={title}>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | YOLO Games", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/meta.png`,
              alt: "Profile",
              width: 1600,
              height: 840,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <NotificationsView />
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

export default ProfilePage;
